import React, { useContext, useState, useRef
    // , useEffect
 } from 'react';
import './SearchForTrip.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import useWindowSize from '../../hooks/useWindowSize';
import Empolyment from '../../images/Employment.svg';
import EmpolymentAR from '../../images/EmploymentAR.svg';

import axios from '../../api/DataTrans';
import Trip from '../../Components/Trip/Trip';
// import io from 'socket.io-client';
const SearchForTrip = () => {
    // const socket = io.connect("https://way-go.vercel.app/");
    const {lang} = useContext(DataContext);
    const [t] = useTranslation("global");
    const {width} = useWindowSize();
    const [from,setFrom] = useState('');
    const [to,setTo] = useState('');
    const [date,setDate] = useState('');
    const ref = useRef(null);
    const coco = useRef(null);
    
    const translate = () => {
        setTimeout(() => {
            ref.current?.scrollIntoView({ behavior: 'smooth' });
        },500);
    }
    const [trips,setTrips] = useState([
        // {'id':1,'companyName':'Qadmoos','from':from,'to':to,
        // 'bus':{'id':10,'type':'VIP','numOfSets':'24','numberOfBus':'14','driverName':'yaser','helpDriverName':'wassem'},
        // 'ticketPrice':'24$','date':'23-10-2023'}
        // ,{'id':2,'companyName':'yaserTours','from':from,'to':to,
        // 'bus':{'id':12,'type':'normal','numOfSets':'42','numberOfBus':'34','driverName':'ahmad','helpDriverName':'moaz'},
        // 'ticketPrice':'10$','date':'23-10-2023'}
    ])
    // useEffect(()=>{
    //     socket.on("availabel",(data)=>{
    //       console.log(data)
    //       setTrips(...trips,data);
    //     })
    //   },[socket,trips]);
    const countries = [
        {'id':1,'name':`${t("search.Damascus")}`,'value':'Damascus'},
        {'id':2,'name':`${t("search.Hama")}`,'value':'Hama'},
        {'id':3,'name':`${t("search.Aleppo")}`,'value':'Aleppo'},
        {'id':4,'name':`${t("search.Homs")}`,'value':'Homs'},
        {'id':5,'name':`${t("search.Latakia")}`,'value':'Latakia'},
        {'id':6,'name':`${t("search.Tartous")}`,'value':'Tartous'},
        {'id':7,'name':`${t("search.Quneitra")}`,'value':'Quneitra'},
    ]
    const serachfortrip = async (e) => {
        e.preventDefault();
        let fromser = '' , toser =''
        switch (from){
            case `${t("search.Damascus")}`:
                fromser = 'Damascus'
                break;
            case `${t("search.Hama")}`:
                fromser = 'Hama'
                break;
            case `${t("search.Aleppo")}`:
                fromser = 'Aleppo'
                break;
            case `${t("search.Homs")}`:
                fromser = 'Homs'
                break;
            case `${t("search.Latakia")}`:
                fromser = 'Latakia'
                break;
            case `${t("search.Tartous")}`:
                fromser = 'Tartous'
                break;
            case `${t("search.Quneitra")}`:
                fromser = 'Quneitra'
                break;     
            default:
                break;                                                                           
        }
        switch (to){
            case `${t("search.Damascus")}`:
                toser = 'Damascus'
                break;
            case `${t("search.Hama")}`:
                toser = 'Hama'
                break;
            case `${t("search.Aleppo")}`:
                toser = 'Aleppo'
                break;
            case `${t("search.Homs")}`:
                toser = 'Homs'
                break;
            case `${t("search.Latakia")}`:
                toser = 'Latakia'
                break;
            case `${t("search.Tartous")}`:
                toser = 'Tartous'
                break;
            case `${t("search.Quneitra")}`:
                toser = 'Quneitra'
                break;     
            default:
                break;                                                                           
        }
        try{
            const response = await axios.post('/customer/searchForTrips',{
                'from':fromser,
                'to':toser,
                'date':date,
              },
              {
                headers:{
                  'Content-Type' : 'application/json'
                },
              },
              );
            //   alert(lang?'تم ارسال الرسالة بنجاح':'the request is sent')
              alert(`from : ${fromser}  ,  to : ${toser}   ,  date : ${date}`)
              console.log(response);
              setTrips(response.data.trips
                // [
            //     {'id':1,'companyName':'Qadmoos','from':from,'to':to,
            //   'bus':{'id':10,'type':'VIP','numOfSets':'24','numberOfBus':'14','driverName':'yaser','helpDriverName':'wassem'},
            //   'ticketPrice':'24$','date':'23-10-2023'}
            //   ,{'id':2,'companyName':'yaserTours','from':from,'to':to,
            //   'bus':{'id':12,'type':'normal','numOfSets':'42','numberOfBus':'34','driverName':'ahmad','helpDriverName':'moaz'},
            //   'ticketPrice':'10$','date':'23-10-2023'}
                // ]
                );
                translate();
        }
        catch(err){
            console.log(err);
        }
    }
  return (
    <div>
    <div className='search_main' style={{
            // justifyContent:lang ? width > 600 ? 'flex-end' : 'center' : width > 600 ? 'flex-end' :  'center',
            flexDirection:lang ? width > 1000 ? 'row' : 'column' : width > 1000 ? 'row-reverse' :  'column',
            paddingTop:width < 1000 ? "70px":'0px',paddingBottom:width < 1000 ? "70px":'0px',
            minHeight:width<1000 ?'':'100vh'
            }}>
        <div className='search_container_box'
             style={{
                // marginLeft:!lang && width > 1000 ? '50px' : '0px',marginRight:lang && width > 1000 ? '70px' : '0px',
                    //  marginTop:width<1000 ?'50px':'0px',
                     flexDirection:width<425?'column':'row',
                     marginLeft:width > 1000 && !lang?'0px':'50px',marginRight:width > 1000 && lang?'0px':'50px',
             }}
        >
            <div className='search_box_1'>
                {!lang && <img src={Empolyment} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>}
                {lang && <img src={EmpolymentAR} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>}
            </div>
        </div>
        <div className='search_container' 
             style={{marginLeft:width > 600 && !lang?'100px':'0px',marginRight:width > 600 && lang?'100px':'0px',
                     justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000 ? '45px':'0px'}}>
            <div className='search_h1' style={{alignItems:lang?'flex-end':'flex-start'}}>
                <p className='search_para'>{t("search.find")}</p>
            </div>
            <div className='search_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                <p className='search_para'>{t("search.searchfor")}</p>
                <p className='search_para'>{t("search.searchfor1")}</p>
            </div>
            <form onSubmit={serachfortrip}>
                <div className='search_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='search_para'>{t("search.From")}</p>
                    <select className='searchInput' required onChange={(e) => setFrom(e.target.value)} value={from}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    >
                         <option>
                         {/* {t("search.From")} */}
                         ـ
                        </option>
                        {countries?.map((country) => {
                        return <option 
                                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                                        key={country.id}>
                            {country.name}
                        </option>
                    })}
                    </select>
                </div>
                <div className='search_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='search_para'>{t("search.to")}</p>
                    <select className='searchInput' required onChange={(e) => setTo(e.target.value)} value={to}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    >
                         <option>
                         {/* {t("search.to")} */}
                         ـ
                        </option>
                        {countries?.map((country) => {
                        return <option  
                                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                                        key={country.id}>
                            {country.name}
                        </option>
                    })}
                    </select>
                </div>
                <div className='search_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='search_para'>{t("search.date")}</p>
                    <input className='searchInput' type='date' required onChange={(e) => setDate(e.target.value)} value={date}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='search_h3' style={{justifyContent:lang?'flex-end':'flex-start'}}>
                    <button type='submit' className='search_sign'>{t("search.search")}</button>
                </div>
            </form>
        </div>
    </div>
    {trips.length > 0 && <><p className='search_h1' style={{textAlign:'center',width:'100%',backgroundColor:'rgb(250,250,250)'}}>{t("search.avalabile")}</p>
    <div
        onClick={() => {coco.current?.scrollIntoView({ behavior: 'smooth' });}}
        ref={ref}
        style={{backgroundColor:'rgb(250,250,250)',maxHeight:'100vh',width:'100%',overflowY:'scroll',display:'flex',flexDirection:'column',alignItems:'center'}}>
        {trips?.map((trip)=>{
            return <Trip key={trip.id} trip={trip}/>
        })}
    </div></>}
    {/* <div 
        ref={coco}
        style={{backgroundColor:'rgb(227,227,227)',height:'100vh',width:'100^'}}>
        asdas   
    </div> */}
    </div>
  )
}

export default SearchForTrip